type CacheKey = 'user' | 'userContract';

export const CacheKeys = {
  user: 'user' as CacheKey,
  userContract: 'userContract' as CacheKey,
};
